// extracted by mini-css-extract-plugin
export default {"portfololio":"Portfolio_portfololio__9ETpP","divider":"Portfolio_divider__Ei53o","portfolio":"Portfolio_portfolio__aRJWE","img":"Portfolio_img__5kdep"};